// Map of route hrefs (locale-agnostic, without /:lang) to dynamic imports
// matching the lazy() chunks in App.tsx. Calling the importer kicks off the
// network fetch so the chunk is in browser cache by the time the user clicks.
//
// We dedupe by href: each importer is only invoked once per session — Vite
// returns the same module promise on subsequent calls, but we still gate to
// avoid creating extra microtasks on every hover.

type Importer = () => Promise<unknown>;

const importers: Record<string, Importer> = {
  "/": () => import("@/pages/Index"),
  "/about": () => import("@/pages/AboutPage"),
  "/achievements": () => import("@/pages/AchievementsPage"),
  "/blog": () => import("@/pages/BlogPage"),
  "/lectures": () => import("@/pages/LecturesPage"),
  "/partners": () => import("@/pages/PartnersPage"),
  "/zebbie": () => import("@/pages/ZebbiePage"),
  "/community": () => import("@/pages/CommunityPage"),
  "/sales": () => import("@/pages/SalesPage"),
  "/profile": () => import("@/pages/ProfilePage"),
  "/privacy": () => import("@/pages/PrivacyPage"),
  "/login": () => import("@/pages/LoginPage"),
  "/signup": () => import("@/pages/SignupPage"),
};

const prefetched = new Set<string>();

export function prefetchRoute(href: string) {
  // Strip locale prefix (/cs, /en) if present
  const normalized = href.replace(/^\/(cs|en)(?=\/|$)/, "") || "/";
  if (prefetched.has(normalized)) return;
  const importer = importers[normalized];
  if (!importer) return;
  prefetched.add(normalized);
  // Fire and forget; swallow errors so a failed prefetch never breaks UX
  importer().catch(() => {
    prefetched.delete(normalized);
  });
}
